import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getStoreCitys } from '@/api/goodsCenter';
import { onlineFoodBrands, exportOnlineOrderData, onlineOrderBrandList } from '@/api/order';
export default {
  name: 'onlineOrderConifg',
  props: {
    order_id: [Number, String],
    currentRowMenu: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    ruleType: String,
    entryType: String,
    // 平台配置  渠道列表 管理中心 订单规则
    /**
     * @description menuType 菜单类型
     * orderDetails - 订单列表-订单详情-订单规则
     * channelCardTypeManage - 管理中心 卡类型管理
     * saleCardTypeManage - 销售工具 卡类型管理
     * customerSet - 客户管理 - 客户列表 - 设置 - 营销参数管理
     */
    menuType: String,
    foodType: String,
    // view - 查看 没有编辑功能  set - 允许编辑
    ruleInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    menusInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    hasEditRule: Boolean,
    blackCityTotal: Number
  },
  data: function data() {
    return {
      blackBrandTotal: 0,
      // 订单级黑名单品牌总数

      citys: [],
      searchForm: {
        region_id: '',
        brand_name: '',
        page: 1,
        pagesize: 20
      },
      totalCount: 0,
      tableData: [],
      // city tree dialog start
      showCityDialog: false,
      cityList: [],
      filterText: '',
      // city tree dialog end

      exportLoading: false,
      dialogType: '',
      // 品牌黑名单 start
      onlineOrderDialog: false,
      onlineOrderList: [],
      checkedOnlineOrder: [],
      tempOnlineOrder: [],
      searchBrand: {
        brand_name: '',
        page: 1,
        pagesize: 20,
        total_count: 0
      }
      // 品牌黑名单 end
    };
  },
  methods: {
    toStore: function toStore(row) {
      var src = "".concat(this.$store.state.user.domainName, "/#/goodsCenter/onlineOrdering?activeName=store&brand_name=").concat(row.brand_name);
      window.open(src, '_blank');
    },
    setBlackOnlineOrder: function setBlackOnlineOrder() {
      var _this = this;
      if (this.dialogType !== 'setBlack') {
        return;
      }
      this.$emit('setBlackOnlineOrder', {
        selectIds: this.checkedOnlineOrder.map(function (i) {
          return i.brand_id;
        }),
        showMsg: false,
        cb: function cb() {
          _this.pageChange(1);
          _this.getBrandList();
          _this.$message.success('操作成功');
          _this.onlineOrderDialog = false;
        }
      });
    },
    selectable: function selectable(row) {
      var selectIds = this.checkedOnlineOrder.map(function (item) {
        return item.brand_id;
      });
      return selectIds.indexOf(row.brand_id) === -1;
    },
    handleSelectOnlineorder: function handleSelectOnlineorder(val) {
      this.tempOnlineOrder = val;
    },
    batchAddOnlineOrder: function batchAddOnlineOrder() {
      this.checkedOnlineOrder = this.checkedOnlineOrder.concat(this.tempOnlineOrder);
      this.tempOnlineOrder = [];
      this.$refs.multipleOnlineOrder.clearSelection();
    },
    getBrandList: function getBrandList(isInit) {
      var _this2 = this;
      onlineOrderBrandList(_objectSpread(_objectSpread({}, this.searchBrand), {}, {
        order_id: this.ruleType === 'cardType' ? 0 : this.order_id,
        rule_id: this.ruleType === 'cardType' ? this.ruleInfo.id : 0,
        menu_id: this.currentRowMenu.id
      }), this.entryType).then(function (res) {
        var _data$brands;
        var data = res.data,
          pages = res.pages;
        _this2.onlineOrderList = data.list;
        _this2.searchBrand.total_count = pages.totalCount || 0;
        _this2.blackBrandTotal = ((_data$brands = data.brands) === null || _data$brands === void 0 ? void 0 : _data$brands.length) || 0;
        if (isInit) {
          _this2.checkedOnlineOrder = data.brands;
        }
      });
    },
    // 设置品牌黑名单 start
    searchOnlineOrderList: function searchOnlineOrderList() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var isInit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.searchBrand.page = page;
      if (isInit) {
        this.checkedOnlineOrder = [];
        this.onlineOrderList = [];
        this.searchBrand.brand_name = '';
      }
      this.getBrandList(isInit);
    },
    delCheckedCake: function delCheckedCake(index) {
      if (this.dialogType !== 'setBlack') {
        return;
      }
      this.checkedOnlineOrder.splice(index, 1);
    },
    clearChecked: function clearChecked() {
      this.checkedOnlineOrder = [];
    },
    // 菜单级规则 end
    // sortChange(val) {
    // 	this.searchForm = {
    // 		...this.searchForm,
    // 		page: 1,
    // 		sort: val.order,
    // 		sortParam: val.order ? val.prop : null
    // 	}
    // 	this.getList({ type: 'allow_brand', ...this.searchForm }, true)
    // },
    loadData: function loadData() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this3.searchForm.page = 1;
              _this3.getList(_objectSpread({
                type: 'allow_brand'
              }, _this3.searchForm), true); // 获取可用品牌数据
              _this3.getBrandList(); // 获取品牌黑名单数量
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    getList: function getList() {
      var _this4 = this;
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var isSetData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return new Promise(function (resolve) {
        onlineFoodBrands(_objectSpread(_objectSpread(_objectSpread({}, _this4.ruleType === 'cardType' ? {
          rule_id: _this4.ruleInfo.id
        } : {
          order_id: _this4.order_id
        }), params), {}, {
          menu_id: _this4.currentRowMenu.id
        })).then(function (res) {
          var _res$data = res.data,
            _res$data$data = _res$data.data,
            data = _res$data$data === void 0 ? [] : _res$data$data,
            _res$data$pages = _res$data.pages,
            pages = _res$data$pages === void 0 ? {} : _res$data$pages,
            _res$data$extend_data = _res$data.extend_data,
            extend_data = _res$data$extend_data === void 0 ? {} : _res$data$extend_data;
          if (isSetData) {
            _this4.tableData = data;
            _this4.totalCount = pages.total_count || 0;
          }
          resolve(res.data);
        });
      });
    },
    searchData: function searchData(type) {
      type === 'reset' && this.$refs.searchForm.resetFields();
      this.pageChange();
    },
    pageChange: function pageChange() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      this.searchForm.page = page;
      this.getList(_objectSpread({
        type: 'allow_brand'
      }, this.searchForm), true);
    },
    // 查看覆盖城市 start
    onClose: function onClose() {
      this.filterText = '';
    },
    filterNode: function filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    openCityDialog: function openCityDialog(citys) {
      this.cityList = citys;
      this.showCityDialog = true;
    },
    // 查看覆盖城市 end
    exportData: function exportData() {
      var _this5 = this;
      this.exportLoading = true;
      exportOnlineOrderData(_objectSpread(_objectSpread(_objectSpread({}, this.ruleType === 'cardType' ? {
        rule_id: this.ruleInfo.id
      } : {
        order_id: this.order_id
      }), this.searchForm), {}, {
        type: 'allow_brand',
        menu_id: this.currentRowMenu.id
      }), this.menuType).then(function (_) {
        _this5.$message.warning('开始生成文件，请在【下载中心】查看进度并下载文件到本地');
      }).finally(function () {
        _this5.exportLoading = false;
      });
    },
    sizeChange: function sizeChange(formName, size) {
      this[formName].pagesize = size;
      if (formName === 'searchBrand') {
        this.searchOnlineOrderList();
      } else {
        this.pageChange();
      }
    },
    openDialog: function openDialog(openType) {
      this.dialogType = openType;
      switch (openType) {
        case 'setBlack':
        case 'viewBlack':
          this.searchOnlineOrderList(1, true);
          this.onlineOrderDialog = true;
          break;
        case 'setFoodCity':
        case 'viewFoodCity':
          this.$emit('openWhiteCity', 1, openType, this.currentRowMenu);
          break;
        case 'setFoodChild':
        case 'viewFoodChild':
          this.$emit('setChildMenu', this.currentRowMenu.childrens, this.currentRowMenu, {
            openType: openType
          });
          break;
      }
    },
    getConfig: function getConfig() {
      var _this6 = this;
      getStoreCitys().then(function (res) {
        _this6.citys = res.data.tree;
      });
    }
  },
  created: function created() {
    var _this7 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            _this7.getConfig();
            _this7.loadData();
          case 1:
            return _context2.a(2);
        }
      }, _callee2);
    }))();
  },
  watch: {
    filterText: function filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  computed: {
    childMenuTotal: function childMenuTotal() {
      var _this$currentRowMenu$ = this.currentRowMenu.childrens,
        childrens = _this$currentRowMenu$ === void 0 ? [] : _this$currentRowMenu$;
      return childrens.filter(function (i) {
        return i.selected == 1;
      }).length;
    },
    hasExportRole: function hasExportRole() {
      var authEnum = {
        orderDetails: '/orders/card-rule-extend/online-foods-v2-export',
        channelCardTypeManage: '/orders/card-rule-extend/online-foods-v2-common-export',
        saleCardTypeManage: '/orders/card-rule-extend/online-foods-v2-sale-export'
      };
      var keys = Object.keys(authEnum);
      if (keys.includes(this.menuType)) {
        // 产品要求 只需要在这三个页面中判断权限即可
        var rolePath = authEnum[this.menuType];
        return this.$hasBtnRoles(rolePath);
      }
      return false;
    }
  }
};